import { ListOverlay, Row } from './ListOverlay.js';
import { dia } from '../lib/fechas.js';
import type { SessionState } from '../lib/session.js';
import { eurosCompacto } from '../lib/etiquetas-metricas.js';
import { rotuloPeriodo } from '../lib/snapshot-types.js';

interface ZohoDeal {
  id: string; name: string; amount: number;
  closingDate: string | null; modifiedTime: string;
  ownerEmail: string | null; ownerName: string | null;
  accountName: string | null;
}

interface Props {
  session: SessionState;
  scope: 'me' | 'team';
  from: string;
  to: string;
  zohoDataCenter: string | null;
}

export function DealsList({ session, scope, from, to, zohoDataCenter }: Props) {
  const q = new URLSearchParams({ scope, from, to });
  const path = `/api/dashboard/zoho/won-deals?${q.toString()}`;
  return (
    <ListOverlay<ZohoDeal>
      session={session}
      title="Oportunidades ganadas · Zoho"
      subtitle={rotuloPeriodo(from, to)}
      fetchPath={path}
      itemsKey="deals"
      emptyMessage="Sin oportunidades ganadas en este rango."
      onItemClick={(d) => {
        // Open the Zoho Deal directly in a new tab.
        const dc = zohoDataCenter ?? 'eu';
        window.open(`https://crm.zoho.${dc}/crm/EntityInfo.do?module=Deals&id=${d.id}`, '_blank', 'noopener');
      }}
      renderRow={(d) => (
        <Row
          left={<>
            <div className="row-title">{d.name}</div>
            <div className="row-sub">
              {d.accountName ?? ''} {d.accountName && d.ownerName ? '·' : ''} {d.ownerName ?? ''}
            </div>
          </>}
          aside={<>
            <div style={{ fontWeight: 600, color: 'var(--ok)' }}>{eurosCompacto(d.amount)}</div>
            <div>{dia(d.closingDate ?? d.modifiedTime)}</div>
          </>}
        />
      )}
    />
  );
}
